import { render, staticRenderFns } from "./detail-inner-item.vue?vue&type=template&id=2fce2ef7&scoped=true"
import script from "./detail-inner-item.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-inner-item.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail-inner-item.vue?vue&type=style&index=0&id=2fce2ef7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce2ef7",
  null
  
)

export default component.exports